// Which open tab answers a Kit page-capture request. It is broadcast to every
// tab with the Kit panel open, and first-upload-used-to-win let a forgotten
// background tab answer for a customer on another page.
//
//   "now"   — this tab is on the page the customer last wrote from
//   "later" — it isn't, but it's the visible tab (they navigated since), so it
//             answers after a grace period in case the right tab exists
//   "never" — it isn't, and it's a background tab
export function captureDecision({ targetPath, pathname, visibilityState }) {
  if (!targetPath) return "now";
  if (targetPath.split("?")[0] === pathname) return "now";
  return visibilityState === "visible" ? "later" : "never";
}
